import React from 'react';
import store from './redux/store';
import HttpsRedirect from 'react-https-redirect';
import './index.css';
import './custom.scss';
import Routers from './Routers';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import { injectStore } from './apiServices/axios';
import 'react-toastify/dist/ReactToastify.css';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { FluentProvider, teamsLightTheme } from '@fluentui/react-components';
import { createRoot } from 'react-dom/client';
import { SidebarProvider, PersistentLayout } from './components/Layout';
import DuplicateTabModal from './components/CommonComponents/DuplicateTabModal';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import TokenService from './apiServices/tokenservices/token.service';
import Cookies from 'js-cookie';

// Migrate existing cookies to have secure/sameSite attributes on app initialization
// This ensures old cookies get updated with new security settings
const refreshToken = Cookies.get('refresh');
if (refreshToken) {
    Cookies.set('refresh', refreshToken, {
        secure: true,
        sameSite: 'strict',
    });
}

// Component to conditionally render layout
const AppContent = () => {
    const location = useLocation();
    const { user } = useSelector(state => state.user);

    // Define routes that should NOT have the layout (auth pages, etc.)
    const noLayoutRoutes = [
        '/',
        '/register',
        '/complete-profile',
        '/forgot-password',
        '/confirm-mail',
        '/secure',
        '/setup-2fa',
        '/authenticate',
        '/request-invite',
        '/reset-password',
        '/noprojects',
        '/NDASuccess',
        '/project',
        '/select-workspace',
        '/no-workspace-access',
        '/nda',
        '/user-settings',
        '/uploadnda',
        '/AddProjectDetails',
        '/cross-project-tasks',
        '/shared/document',
        '/validate-invite',
    ];

    // Check if current route should have layout
    const shouldHaveLayout = !noLayoutRoutes.some(route => location.pathname === route || location.pathname.startsWith(route + '/')) && user?.id; // Only show layout for authenticated users

    return (
        <>
            {shouldHaveLayout ? (
                <PersistentLayout>
                    <Routers />
                </PersistentLayout>
            ) : (
                <Routers />
            )}
            {user?.id ? <DuplicateTabModal /> : null}
        </>
    );
};

// import theme from './theme';
injectStore(store);
let persistor = persistStore(store);
const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
    <Provider store={store}>
        <HttpsRedirect>
            <PersistGate loading={null} persistor={persistor}>
                <FluentProvider theme={teamsLightTheme}>
                    <Router>
                        <SidebarProvider>
                            <AppContent />
                            <ToastContainer
                                position="top-center"
                                autoClose={5000}
                                style={{ zIndex: 1000000 }}
                                hideProgressBar
                                newestOnTop={false}
                                rtl={false}
                                closeOnClick
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover
                            />
                        </SidebarProvider>
                    </Router>
                </FluentProvider>
            </PersistGate>
        </HttpsRedirect>
    </Provider>,
);
